export default function Footer() {
  return (
    <footer
      className="border-t av-hairline mt-24 py-10 text-center text-[#A39E93] text-sm"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="font-serif-display italic text-2xl text-[#F7F4EE] mb-2">
          ArtVision · NMA Agency
        </div>
        <p>Artisti e spettacoli per la tua piazza</p>
        <div className="mt-5 flex flex-col sm:flex-row justify-center items-center gap-3 text-[#F7F4EE]">
          <a
            href="https://wa.me/393473188828"
            target="_blank"
            rel="noopener noreferrer"
            className="av-pill av-pill-gold text-xs"
            data-testid="footer-whatsapp-btn"
          >
            WhatsApp +39 347 318 8828
          </a>
          <a
            href="mailto:napolitanomaxagency@live.com?subject=Richiesta%20contatto%20—%20NMA%20Agency"
            className="av-pill av-pill-ghost text-xs"
            data-testid="footer-email-btn"
          >
            napolitanomaxagency@live.com
          </a>
        </div>
        <div className="flex justify-center flex-wrap gap-4 mt-5 text-xs">
          <a href="/chi-siamo" className="hover:text-[#E5A93C] transition-colors" data-testid="footer-about">
            Chi siamo
          </a>
          <a href="/servizi" className="hover:text-[#E5A93C] transition-colors" data-testid="footer-services">
            Servizi
          </a>
          <a href="/portfolio" className="hover:text-[#E5A93C] transition-colors" data-testid="footer-portfolio">
            Portfolio eventi
          </a>
          <a href="/candidati" className="hover:text-[#E5A93C] transition-colors" data-testid="footer-apply">
            Candidati
          </a>
        </div>
        <div className="flex justify-center flex-wrap gap-4 mt-3 text-xs text-[#A39E93]/80">
          <a href="/privacy" className="hover:text-[#E5A93C] transition-colors" data-testid="footer-privacy">
            Privacy Policy
          </a>
          <a href="/cookie" className="hover:text-[#E5A93C] transition-colors" data-testid="footer-cookies">
            Cookie Policy
          </a>
          <a href="/termini" className="hover:text-[#E5A93C] transition-colors" data-testid="footer-terms">
            Termini
          </a>
        </div>
        <p className="mt-4 text-xs text-[#A39E93]/80">
          © {new Date().getFullYear()} — Direttore Massimiliano Napolitano · Tutti i diritti riservati
        </p>
        <p className="mt-1 text-[10px] text-[#A39E93]/60 leading-relaxed">
          NMA Agency di Massimiliano Napolitano · C.F. NPLMSM74B11F924E · Sede legale: Via Alfredo D'Andrade 5, 10080 Rivara (TO)
        </p>
      </div>
    </footer>
  );
}
